


































































































































































import Vue from 'vue';

import { Player } from '@/types';

export default Vue.extend({
  name: 'Checkout',

  data() {
    return {
      dialog: false,
      players: [],
      items: ['Gulur', 'Rauður', 'Grænn', 'Blár'],

    };
  },

  computed: {
    selectedQuestions() {
      return this.$store.getters.selectedQuestions;
    },
    hasSelectedQuestions() {
      return this.$store.getters.selectedQuestions.length > 0;
    },
    queryCount(): number {
      return this.$store.getters.queryCount;
    },
  },

  methods: {
    deselectQuestion(id: number): void {
      this.$store.dispatch('deselectQuestion', id);
    },
    download(): void {
      // https://github.com/thatsus/vue-csv-downloader/blob/master/src/CsvDownload.vue
    },
    resetSelected(): void {
      this.$store.dispatch('resetSelectedQuestions');
    },
    play(): void {
      const players: Array<Player> = [];

      for (let i = 0; i < this.players.length; i += 1) {
        const player: Player = {
          name: this.players[i],
          score: 0,
        };
        players.push(player);
      }

      this.$store.dispatch('startGame', players);

      this.dialog = false;

      this.$router.push('/spila');
    },
  },

});
